import React, { PropTypes } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import sortBy from "lodash/sortBy";

import { memberCoverageStatuses } from "./enums/";
import {
  ALL_INACTIVE_REASONS,
  OTHER as OTHERINACTIVITYREASON,
} from "./enums/memberCoverageInactivityReasons";
import { PM } from "../../../../enums/businessAccountTypes";

const MemberCoverageStatus = (props) => {
  const { authLanguageCode, memberCoverage, businessAccountType } = props;
  if (!memberCoverage) {
    return (
      <div className={`status status-indicator status-inactive`}>
        <span>
          <FormattedMessage id="status.inactive" />
        </span>
      </div>
    );
  }
  const isInactive = memberCoverage.isInactive && memberCoverage != "false";
  const reasonType = ALL_INACTIVE_REASONS.find(
    (reason) => reason.value == memberCoverage.isInactiveReasonType
  );
  const guarantees = memberCoverage.memberCoverageGuarantees || [];
  let hasTooltip = false;

  if (isInactive && businessAccountType === PM.value) {
    hasTooltip = !!reasonType;
  } else {
    hasTooltip = !!guarantees && guarantees.length > 0;
  }

  if (!hasTooltip) {
    return (
      <div
        className={`status status-indicator status-${
          isInactive ? "inactive" : "active"
        }`}
      >
        <span>
          <FormattedMessage
            id={
              memberCoverageStatuses.find(
                (status) => status.value == memberCoverage.isInactive
              ).key
            }
          />
        </span>
      </div>
    );
  }

  const sortedGuarantees = sortBy(
    guarantees,
    (memberCoverageGuarantee) =>
      memberCoverageGuarantee.guarantee.localizations[authLanguageCode].name
  );
  const message =
    isInactive && reasonType && businessAccountType === PM.value ? (
      reasonType == OTHERINACTIVITYREASON ? (
        memberCoverage.isInactiveOtherReason
      ) : (
        <FormattedMessage id={reasonType.key} />
      )
    ) : (
      <div>
        {sortedGuarantees.map((memberCoverageGuarantee, i) => {
          return (
            <div key={i}>
              {
                memberCoverageGuarantee.guarantee.localizations[
                  authLanguageCode
                ].name
              }
            </div>
          );
        })}
      </div>
    );
  const tooltip = (
    <Tooltip id="tooltip" className="guarantee-line-tooltip">
      {message}
    </Tooltip>
  );
  return (
    <div
      className={`status status-indicator status-${
        isInactive ? "inactive" : "active"
      }`}
    >
      <OverlayTrigger placement="bottom" overlay={tooltip}>
        <span>
          <FormattedMessage
            id={
              memberCoverageStatuses.find(
                (status) => status.value == memberCoverage.isInactive
              ).key
            }
          />
        </span>
      </OverlayTrigger>
    </div>
  );
};

MemberCoverageStatus.propTypes = {
  authLanguageCode: PropTypes.string.isRequired,
  memberCoverage: PropTypes.object,
  businessAccountType: PropTypes.number,
};

export default MemberCoverageStatus;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/MemberCoverageStatus.js